"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE = exports.STATUS = exports.PRIVACY_STATUS = void 0;
exports.PRIVACY_STATUS = {
    UNKNOWN: 'UNKNOWN',
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
};
exports.STATUS = {
    UNKNOWN: 'UNKNOWN',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    BLOCKED: 'BLOCKED',
    OFFLINE: 'OFFLINE',
};
exports.ROLE = {
    UNDEFINED_ROLE: 'UNDEFINED_ROLE',
    MEMBER: 'MEMBER',
    OWNER: 'OWNER',
    CONTRIBUTOR: 'CONTRIBUTOR',
};
//# sourceMappingURL=constants.js.map